import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  CoreActionOpenExternalLink,
  ENVIRONMENT,
  Environment
} from '@bepatient/core';
import { Store } from '@ngrx/store';
// import { environment } from 'apps/smart-app/src/environments/environment';

@Component({
  selector: 'app-privacy-content',
  templateUrl: './privacy-content.component.html',
  styleUrls: ['./privacy-content.component.scss'],
  standalone: false
})
export class PrivacyContentComponent implements OnInit {
  private router = inject(Router);
  private store$ = inject(Store);
  private env = inject<Environment>(ENVIRONMENT);

  logoImg = 'instance-dyn/assets/images/privacy_logo.svg';
  isMyAccountPage: boolean = false;

  ngOnInit(): void {
    this.isMyAccountPage =
      this.router.url === '/my-account-privacy-policy' ? true : false;
  }

  /**
   * Open the External privacy policy link in
   * system default browser
   */
  privacyStatementClick() {
    const privacy_url = this.env?.privacyStatementUrl;
    this.store$.dispatch(new CoreActionOpenExternalLink(privacy_url));
  }
}
